export const SET_CURRENT_CODE = 'SET_CURRENT_CODE';

export const setCurrentCode = (currentCode) => ({
    type: SET_CURRENT_CODE, currentCode
});
